export const FILTERS = [
  {
    key: 'all',
    value: 'All'
  },
  {
    key: 'benefits',
    value: 'Benefits',
  },
  {
    key: 'cards',
    value: 'Cards',
  },
  {
    key: 'hero',
    value: 'Hero',
  },
  {
    key: 'hub',
    value: 'Hub',
  },
  {
    key: 'skinny',
    value: 'Skinny',
  },
  {
    key: 'support',
    value: 'Support',
  },
  {
    key: 'others',
    value: 'Others',
  },
];

export const FILTERKEYS = {
  'benefits': 'Benefits',
  'cards'   : 'Cards',
  'hero'    : 'Hero',
  'hub'     : 'Hub',
  'skinny'  : 'Skinny',
  'support' : 'Support',
  'others'  : 'Others',
};



// WEBPACK FOOTER //
// ./src/containers/components/Banner/constants/index.js